import { SerializedConstructor } from '@langchain/core/load/serializable';

import { useCallback } from 'react';

import { typedMemo } from '@/utils/memo';
import { isSerializedConstructor } from '@/utils/serialized';

import { ManifestEditorProps, ManifestPreviewProps } from './Manifest.utils';
import {
  ManifestConstructor,
  ManifestConstructorPreview,
} from './serialized/ManifestConstructor';
import {
  ManifestGeneric,
  ManifestGenericPreview,
} from './serialized/ManifestGeneric';

export const Manifest = typedMemo(function <T>(props: ManifestEditorProps<T>) {
  const { value, onChange: onChangeProps } = props;
  const onChange = useCallback(
    (value: SerializedConstructor) => {
      onChangeProps(value as T);
    },
    [onChangeProps]
  );

  if (isSerializedConstructor(value)) {
    return (
      <ManifestConstructor
        {...props}
        value={value as SerializedConstructor}
        onChange={onChange}
      />
    );
  }

  return <ManifestGeneric {...props} />;
});

export function ManifestPreview<T>(props: ManifestPreviewProps<T>) {
  if (isSerializedConstructor(props.value)) {
    return <ManifestConstructorPreview {...props} value={props.value} />;
  }
  return <ManifestGenericPreview {...props} />;
}
